import * as VueRouter from "vue-router";

import TurtleWatch from './components/TurtleWatch.vue';
import HumanWave from './components/HumanWave.vue';
import TurtleGuardian from './components/TurtleGuardian.vue';
import TurtleGuardianintro from './components/TurtleGuardianopening.vue';
import TurtleWatchintro from './components/TurtleWatchopening.vue';
import HumanWaveintro from './components/HumanWaveopening.vue';



const routes = [
  {
    path: '/',
    name: 'TurtleGuardianintro',
    component: TurtleGuardianintro,
    meta: { backgroundClass: 'background-turtle-guardian-intro' },
  },
  {
    path: '/turtle-guardian',
    name: 'TurtleGuardian',
    component: TurtleGuardian,
    meta: { backgroundClass: 'background-turtle-guardian' },
  },
  {
    path: '/human-waveintro',
    name: 'HumanWaveintro',
    component: HumanWaveintro,
    meta: { backgroundClass: 'background-human-wave-intro' },
  },
  {
    path: '/human-wave',
    name: 'HumanWave',
    component: HumanWave,
    meta: { backgroundClass: 'background-human-wave' },
  },
  {
    path: '/turtle-watchintro',
    name: 'TurtleWatchintro',
    component: TurtleWatchintro,
    meta: { backgroundClass: 'background-turtle-watch-intro' },
  },
  {
    path: '/turtle-watch',
    name: 'TurtleWatch',
    component: TurtleWatch,
    meta: { backgroundClass: 'background-turtle-watch' },
  }
];

export const router = VueRouter.createRouter({
  history: VueRouter.createWebHashHistory(),
  routes,
});
